import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { FloatingLabel, Form } from "react-bootstrap";
import { FollowUpPlaceService } from "../../../services/FollowUpPlaceService";
import { useNavigate } from "react-router-dom";
import LoadingModal from "../../components/LoadingModal.js";
import AlertModal from "../../../components/AlertModal.js";
import styles from "../../../styles/Modal.module.css";

function AddFollowUpPlace(props) {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const [followUpPlace, setFollowUpPlace] = useState({ name: "" });
  const [error, setError] = useState({ name: "" });

  // Alert state
  const [alertData, setAlertData] = useState({
    show: false,
    title: "",
    message: "",
    variant: "success",
  });

  const validation = () => {
    let tempError = { name: "" };
    let valid = true;
    if (!followUpPlace.name.trim()) {
      tempError.name = "Follow Up Place is required";
      valid = false;
    }
    setError(tempError);
    return valid;
  };

  const saveFollowUpPlace = async () => {
    if (!validation()) return;
  
    setLoading(true);
    try {
      const res = await FollowUpPlaceService.addFollowUpPlace(followUpPlace);
      if (res.status === 200) {
        setFollowUpPlace({ name: "" });
        props.onHide();                  
        if (props.onClose) {
          props.onClose({ status: "success", message: res.message || "Follow Up Place added successfully!" });
        }
      } else {
        throw new Error(res.message || "Error while adding Follow Up Place");
      }
    } catch (error) {
      props.onClose && props.onClose({
        status: "error",
        message: error.message || "Failed to add Follow Up Place. Please try again."
      });
    } finally {
      setLoading(false);
    }
  };
  

  const handleAlertClose = () => {
    setAlertData((prev) => ({ ...prev, show: false }));
    if (alertData.variant === "success") {
      navigate("/followup-place");
    }
  };

  return (
    <>
      {/* Add Follow Up Place Modal */}
      <Modal {...props} size="md" centered className={styles.modalShow}>
        <Modal.Header closeButton className={styles.modalHeader}>
          <Modal.Title className={styles.modalTitle}>
            <i className="fas fa-plus-circle me-2"></i>
            Add New Follow Up Place
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.modalBody}>
          <div className={styles.formGroup}>
            <FloatingLabel
              controlId="followUpPlace"
              label={
                <>
                  Follow Up Place <span className="text-danger">*</span>
                </>
              }
            >
              <Form.Control
                type="text"
                placeholder="Enter Follow Up Place"
                value={followUpPlace.name}
                onChange={(e) => setFollowUpPlace({ ...followUpPlace, name: e.target.value })}
                isInvalid={!!error.name}
              />
              <Form.Control.Feedback type="invalid">
                {error.name}
              </Form.Control.Feedback>
            </FloatingLabel>
          </div>
        </Modal.Body>
        <Modal.Footer className={styles.modalFooter}>
          <Button
            variant="success"
            onClick={saveFollowUpPlace}
            className={styles.primaryButton}
            disabled={loading}
          >
            {loading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm me-1"
                  role="status"
                  aria-hidden="true"
                ></span>
                Saving...
              </>
            ) : (
              <>
                <i className="fas fa-save me-1"></i>
                Save Follow Up Place
              </>
            )}
          </Button>
          <Button
            variant="danger"
            onClick={props.onHide}
            className={styles.secondaryButton}
          >
            <i className="fas fa-times me-1"></i>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      <LoadingModal show={loading} />

      <AlertModal
        show={alertData.show}
        onHide={handleAlertClose}
        title={alertData.title}
        message={alertData.message}
        variant={alertData.variant}
        onClose={props.onClose}
      />
    </>
  );
}

export default AddFollowUpPlace;
